import { ShopperAgentChannelsConfigSchema } from "@redotech/redo-shopper-agent-settings-common/channel-config";
import { ShopperAgentEmailConfigSchema } from "@redotech/redo-shopper-agent-settings-common/email-config";
import { ShopperAgentEscalationConfigInputSchema } from "@redotech/redo-shopper-agent-settings-common/escalation-config";
import { ShopperAgentRcsConfigSchema } from "@redotech/redo-shopper-agent-settings-common/rcs-config";
import { AgentReturnWindowGraceSchema } from "@redotech/redo-shopper-agent-settings-common/return-window-grace";
import { ShopperAgentSupervisorConfigSchema } from "@redotech/redo-shopper-agent-settings-common/supervisor-config";
import * as z from "zod";

export const updateBaseShopperAgentSettings = {
  name: "updateBaseShopperAgentSettings" as const,
  input: z.object({
    enabled: z.boolean().optional(),
    returnWindowGrace: AgentReturnWindowGraceSchema.nullable().optional(),
    iMessageConfig: z.object({ enabled: z.boolean().optional() }).optional(),
    rcsConfig: ShopperAgentRcsConfigSchema.optional(),
    emailConfig: ShopperAgentEmailConfigSchema.optional(),
    escalationConfig:
      ShopperAgentEscalationConfigInputSchema.nullable().optional(),
    personaConfig: z.object({ name: z.string().optional() }).optional(),
    recoverConfig: z.object({ enabled: z.boolean().optional() }).optional(),
    replyConfig: z.object({ enabled: z.boolean().optional() }).optional(),
    supervisorConfig: ShopperAgentSupervisorConfigSchema.nullable().optional(),
    channels: ShopperAgentChannelsConfigSchema.optional(),
    /** Playbook edits stay drafted until Publish. Other surfaces omit this. */
    stageDraft: z.boolean().optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
